import deepSignApi from '@/api/deepsign/deepsignApi.ts';
import type { AddSignee } from '@/types/AddSignee.ts';
import type { UpdateSignee } from '@/types/deepsign/UpdateSignee.ts';
import type { Signee } from '@/types/Signee.ts';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';

/**
 * Create a signee on a document.
 *
 * `POST /api/v1/documents/{documentId}/signees`
 *
 * Uses the local payload types which are ahead of the generated
 * `@deepcloud/api-deep-sign` SDK and therefore support the newer
 * `fileSignatureFields` map for multi-file (envelope) signature placement.
 */
export function createDocumentSignee(
  documentId: string,
  data: AddSignee,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Signee>> {
  return deepSignApi.post<Signee>(
    `documents/${documentId}/signees`,
    data,
    config
  );
}

/**
 * Update a signee on a document.
 *
 * `PUT /api/v1/documents/{documentId}/signees/{signeeId}`
 *
 * Uses the local payload types which support `fileAutographPositions`, enabling
 * a signee to carry an arbitrary number of placeholders across files.
 */
export function updateDocumentSignee(
  documentId: string,
  signeeId: string,
  data: UpdateSignee,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Signee>> {
  return deepSignApi.put<Signee>(
    `documents/${documentId}/signees/${signeeId}`,
    data,
    config
  );
}
